export const Icon = () => {
    return (
        <svg viewBox="0 0 9 14" width="9" height="14" fill="none" stroke="#D4BC87">
            <path d="M0.833984 0.5L7.33398 7L0.833984 13.5" strokeLinecap="round" />
        </svg>
    );
};
